import Image from '../../Atoms/Image';
import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import Button from '../../Atoms/Button';
import Tag from '../../Atoms/Tag';
import SocialBar from '../../Molecules/SocialBar';
import CardContact from '../../Molecules/CardContact';
import ChatMessageList from '../../Organisms/ChatMessageList';
import { MeshMosaicSmall } from '../../Molecules/MeshMosaic';

import svg from '../../../constants/svg';

import bgMesh from '../../../assets/img/contact-bg.png';
import candidate6 from '../../../assets/img/candidate-bas-big.webp';
import contact1 from '../../../assets/img/contact-1.webp';
import contact2 from '../../../assets/img/contact-2.webp';
import contact3 from '../../../assets/img/contact-3.webp';
import InputText from '../../Atoms/InputText';

const messages = [
  {
    title: 'Elmar Koopman',
    subtitle: 'Procesoperator',
    text:
      'Ik was toe aan iets nieuws en de service van Synsel sprak mij erg aan. Het was vooral fijn om bij' +
      ' verschillende bedrijven op gesprek te gaan, want zo kon ik een goede afweging maken en was mijn keuze voor' +
      ' VDL Weweler de beste. Wat ik ook handig vond, was dat ze me hielpen om het beste uit de arbeidsvoorwaarden' +
      ' te halen. Nu ga ik na een werkdag blij naar huis als ik weer een lekker drukke dag heb gehad en alles goed is verlopen.',
    img: {
      src: candidate6
    },
    time: '18.43'
  },
  {
    title: 'Joost Gilbers',
    subtitle: 'Monteur (service)',
    text: (
      <span>
        Ik kwam per toeval bij een vacature van Synsel
        terecht. Nadat ik had gesolliciteerd, werd ik gebeld
        en verliep het contact erg soepel. Ze handelden snel
        en mijn wensen werden echt serieus genomen. Ik werk
        nu als <a href="#!">Monteur</a> in de service bij
        Royal Reesink. Ik ga na een werkdag echt blij naar
        huis wanneer ik weer een uitdagende & mooie klus heb
        gehad en de klant mij met een grote glimlach uit
        staat te zwaaien.
      </span>
    ),
    img: {
      src: candidate6
    },
    time: '18.15'
  },
  {
    title: 'Koen Willems',
    subtitle: 'Software Engineer/PLC Engineer',
    text: (
      <span>
        Ik ben bij Synsel gaan werken, omdat ik een paar
        aanbiedingen kreeg van bedrijven die ik interessant
        vond en ik had die zelf ook nog niet gevonden. Ik
        werk nu als <a href="#!">Software Engineer</a> PLC
        bij Van Doren Engineers en ik ga echt blij naar huis
        als ik goed werk heb geleverd, maar tegelijkertijd
        ook een gezellige dag heb gehad. Ik raad werken bij
        Synsel zeker aan als je zoekt naar een baan, maar
        niet de juiste vacature kunt vinden. Synsel kan die
        baan vaak wel bieden.
      </span>
    ),
    img: {
      src: candidate6
    },
    time: '13.15'
  },
  {
    title: 'Robin Huiskamp',
    subtitle: 'Mechanical Engineer',
    text: (
      <span>
        Ik ben Robin en ik werk als{' '}
        <a href="#!">Mechanical Engineer</a> bij DG Press
        Services. Ik ben bij Synsel gaan werken, omdat ik op
        zoek was naar een nieuwe uitdaging. Samen met Joost
        hebben we een perfect aansluitende functie voor mij
        gevonden. Ik ga na een werkdag blij naar huis
        wanneer ik iets nieuws heb geleerd of als ik een
        stuk verder ben gekomen met een uitdagend project.
        Ik zou Synsel zeker aanraden als je net als ik een
        baan zoekt met uitdaging en waar je snel kunt
        beginnen.
      </span>
    ),
    img: {
      src: candidate6
    },
    time: '13.18'
  },
  {
    title: 'Yannick Luitjens',
    subtitle: 'Control Engineer',
    text: (
      <span>
        Voor mij was uiteindelijk de positiviteit en het
        enthousiasme van Synsel met daarbij het gevoel dat
        Synsel voor mij een passende uitdaging kon vinden de
        beslissende factor. Ik ben aan de slag gegaan als
        Control Engineer bij ICT Automatisering waar ik
        tevreden naar huis ga als ik bijvoorbeeld een
        mijlpaal in het project heb gehaald (stuk software
        af heb), maar ook wanneer ik een FAT of
        inbedrijfstelling goed heb kunnen afsluiten met
        daarbij een tevreden klant. Ik zou Synsel zeker
        aanraden wanneer je nog niet helemaal weet welke
        arbeidsmogelijkheden er voor je zijn en je nog niet
        geheel bekend bent met welke interessante bedrijven
        er te vinden zijn die bij jou passen.
      </span>
    ),
    img: {
      src: candidate6
    },
    time: '13.20'
  },
  {
    title: 'Bas Kloppers',
    subtitle: 'Monteur Technische Dienst',
    text: (
      <span>
        Ik ben voor Synsel gaan werken omdat ik via een{' '}
        <a href="#!">vacature</a> op Indeed terecht kwam op
        de website. Ik heb gereageerd op de vacature en
        zodoende kwam ik met jullie in contact. Het voelde
        meteen goed en prettig. Je kunt altijd een appje
        sturen of mailtje waar gelijk iets mee gedaan wordt.
        Daarbij komt dat jullie mij ontzettend hebben
        geholpen door kieskeurig te zijn in het zoeken naar
        een baan. Door vragen te stellen over wat ik
        bijvoorbeeld écht belangrijk vind in een baan. Hier
        ga je over nadenken en dan kun je ook de beste
        beslissing maken over wat het best bij je past.
        Inmiddels werk ik bijna een jaar met veel plezier
        als{' '}
        <a href="#!">
          onderhoudsmonteur in de technische dienst
        </a>{' '}
        van <a href="#!">Nestle</a>. Dat heb ik mede aan
        jullie te danken!
      </span>
    ),
    img: {
      src: candidate6
    },
    time: '13.22'
  }
];

function Contact() {
  return (
    <>
      <div
        className="flex w-full rounded-b-xl bg-sl-blue px-7 pb-4 pt-32 text-white xsm:pb-10 lg:pb-32 lg:pt-52"
        style={{
          backgroundImage: `url(${bgMesh}), linear-gradient(225deg,#0e1c6b,#23275b)`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center bottom',
          backgroundSize: 'contain'
        }}
      >
        <div className="relative mx-auto flex w-full max-w-7xl flex-col items-stretch justify-between gap-7 md:gap-14 lg:flex-row">
          <div className="w-full lg:w-1/2">
            <div className="mx-auto flex max-w-md flex-col gap-10 lg:ml-0">
              <Title as="h1" size={2} color="inherit">
                Wij staan voor je klaar!
              </Title>
              <Text color="inherit">
                <span className="text-white">
                  Jij weet wat je wil en wij weten waar je
                  dat kan doen. Level up en kom in contact
                  met de meest aansprekende technische
                  werkgevers van Nederland.
                </span>
              </Text>
              <SocialBar
                className="justify-start"
                iconClassName="text-white"
                socialItems={[
                  {
                    icon: 'facebook',
                    url: 'https://www.facebook.com/synseltechniek'
                  },
                  {
                    icon: 'linkedin',
                    url: 'https://www.linkedin.com/company/synsel-techniek'
                  },
                  {
                    icon: 'instagram',
                    url: 'https://www.instagram.com/synseltechniek'
                  }
                ]}
              />
            </div>
          </div>
          <div className="relative -mx-4 xsm:-mx-0 lg:w-1/2">
            <div className="top-0 left-0 mx-auto flex h-auto max-w-md flex-col rounded-xl bg-white p-7 shadow-light md:w-full lg:absolute lg:mr-0 lg:max-w-full">
              <div className="mb-7">
                <Title as="h2" size={4} weight={700}>
                  Jouw bericht aan ons
                </Title>
                <Text>
                  Je hoort binnen 1 werkdag van ons
                </Text>
              </div>
              <form
                action="#!"
                className="flex flex-col gap-y-3"
              >
                <InputText
                  label="Voornaam"
                  name="first-name"
                  autoComplete="first-name"
                />
                <InputText label="Achternaam" />
                <InputText label="E-mailadres" />
                <InputText label="Telefoonnumer" />
                <InputText
                  as="textarea"
                  label="Je bericht"
                  className="mb-3"
                />
                <Button
                  className="self-start"
                  text="Verstuur bericht"
                  color="secondary"
                  shadow
                  iconName="paper-plane"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-white py-10 lg:py-20">
        <div className="mx-auto flex w-full max-w-7xl flex-col px-7">
          <div className="w-full lg:w-1/2">
            <Title
              as="h3"
              size={4}
              weight={400}
              className="mb-3"
            >
              <span>
                Wij zijn op dit moment{' '}
                <strong>
                  <b>bereikbaar</b>
                </strong>
              </span>
            </Title>
            <Tag
              icon="clock"
              text="ma - vr 08.00 - 22.00 uur"
              className="text-lg text-sl-gray md:text-xl lg:text-2xl"
            />
          </div>
          <div className="mt-5 grid gap-3 py-5 sm:grid-cols-2 sm:gap-5 md:grid-cols-4 lg:mt-14 lg:gap-7">
            <CardContact
              title="Bel"
              description="Direct contact"
              text="088 - 3231300"
              icon="phone"
              urlType="tel"
              url="#!"
            />
            <CardContact
              title="Chat"
              description="Direct antwoord"
              text="Chat met ons"
              icon="comments"
              url="#!"
            />
            <CardContact
              title="App"
              description="Binnen 2 uur reactie"
              text="0619734306"
              icon="whatsapp"
              url="#!"
            />
            <CardContact
              title="Mail"
              description="Binnen 1 dag reactie"
              text="talent@synsel.nl"
              icon="mail"
              url="#!"
              urlType="mail"
            />
          </div>
        </div>
      </div>
      <div className="bg-white lg:px-7">
        <div
          className="relative w-full overflow-hidden rounded-xl bg-sl-indigo px-7 py-10 text-center text-white lg:py-32"
          style={{
            backgroundImage:
              'linear-gradient(225deg,#606af8,#5f6fff)'
          }}
        >
          <div className="relative z-10 mx-auto w-full max-w-5xl">
            <Title color="inherit" weight={400}>
              <span>
                App onze <strong>kandidaten</strong>
              </span>
            </Title>
            <Text
              font="circular"
              color="inherit"
              weight={500}
            >
              <span className="text-lg md:text-xl lg:text-2xl">
                En ontdek hun verhalen.
              </span>
            </Text>
            <ChatMessageList
              items={messages}
              className="pt-20"
            />
          </div>
          <div className="pointer-events-none absolute right-0 top-0 z-0">
            <Image
              src={svg.chatDecor}
              alt="description"
              className="w-64 max-w-xl md:w-auto lg:max-w-full"
            />
          </div>
        </div>
      </div>
      <div className="relative z-10 bg-white pt-7 lg:px-7">
        <div
          className="relative w-full rounded-xl py-10 text-center text-sl-blue lg:py-32"
          style={{
            backgroundImage:
              'linear-gradient(135deg,rgba(35,39,91,.05),rgba(35,39,91,.02))'
          }}
        >
          <div className="mx-auto flex w-full max-w-7xl flex-col items-stretch justify-between gap-7 px-7 lg:flex-row">
            <div className="flex w-full flex-col items-start gap-7 text-left lg:w-1/2">
              <Title as="h2" weight={600} color="inherit">
                <span className="text-4xl md:text-5xl lg:text-6xl">
                  Wij zijn Synsel Techniek
                </span>
              </Title>
              <Text
                color="inherit"
                font="circular"
                className="mb-7"
              >
                <span className="text-xl md:text-2xl lg:text-3xl">
                  Dé werkgever voor technici in Nederland.
                </span>
              </Text>
              <Button
                text="Lees meer over Synsel"
                color="primary"
                iconName="arrow-right"
                shadow
              />
            </div>
            <div className="w-full lg:w-1/2">
              <div className="h-full">
                <MeshMosaicSmall
                  images={[
                    {
                      src: contact1,
                      alt: 'Wiyanna'
                    },
                    {
                      src: contact2,
                      alt: 'Wiyanna'
                    },
                    {
                      src: contact3,
                      alt: 'Wiyanna'
                    }
                  ]}
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
